
import React, { useState, useRef } from "react";
import { TailwindSpinner } from "../Spinner/Spinner";
import { useUploadNewEnrollmentFile } from "../../hooks/Muitation/useUploadNewEnrollmentFile";
import SuccessModal from "./SuccessModal";

const UploadModal = ({ open, setOpen, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false); // new state
  const inputRef = useRef();

  const { mutate: uploadFile, isPending } = useUploadNewEnrollmentFile({
    onSuccess: () => {
      setShowSuccess(true); // show success modal
      onSuccess(); // callback if needed
    },
    onError: () => {
      console.log("Upload failed. Try again.");
    },
  });

  const allowedTypes = [
    "text/csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && allowedTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      console.log("Only CSV or Excel files are allowed.");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && allowedTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      console.log("Only CSV or Excel files are allowed.");
    }
  };

  const handleUpload = () => {
    if (!selectedFile) {
      console.log("Select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    uploadFile(formData);
  };

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-md w-[400px] p-6">
            <h2 className="text-lg font-semibold mb-4">Upload Enrollment File</h2>

            {/* DRAG & DROP AREA */}
            <div
              className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center cursor-pointer"
              onClick={() => inputRef.current.click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              {selectedFile ? (
                <p className="text-green-700 font-medium">{selectedFile.name}</p>
              ) : (
                <p className="text-gray-500">Click or drag CSV/Excel file here</p>
              )}

              <input
                type="file"
                ref={inputRef}
                className="hidden"
                accept=".csv, .xlsx, .xls"
                onChange={handleFileSelect}
              />
            </div>

            {/* BUTTONS */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                className="px-4 py-2 rounded bg-gray-200 text-gray-800"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>

              <button
                className="px-5 py-2 rounded bg-blue-600 text-white"
                disabled={isPending}
                onClick={handleUpload}
              >
                {isPending ? 'Processing...' : "Upload"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SUCCESS MODAL */}
      {showSuccess && (
        <SuccessModal
          setOpen={setShowSuccess}
        />
      )}
    </>
  );
};

export default UploadModal;



// import React, { useState, useRef } from "react";
// import { TailwindSpinner } from "../Spinner/Spinner";
// import { useUploadNewEnrollmentFile } from "../../hooks/Muitation/useUploadNewEnrollmentFile";

// const UploadModal = ({ open, setOpen, onSuccess }) => {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const inputRef = useRef();

//   const { mutate: uploadFile, isLoading } = useUploadNewEnrollmentFile({
//     onSuccess: () => {
//       onSuccess();
//     },
//     onError: () => {
//       console.log("Upload failed. Try again.");
//     },
//   });

//   const allowedTypes = [
//     "text/csv",
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     "application/vnd.ms-excel",
//   ];

//   const handleFileSelect = (e) => {
//     const file = e.target.files[0];
//     if (file && allowedTypes.includes(file.type)) {
//       setSelectedFile(file);
//     } else {
//       console.log("Only CSV or Excel files are allowed.");
//     }
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     if (file && allowedTypes.includes(file.type)) {
//       setSelectedFile(file);
//     } else {
//       console.log("Only CSV or Excel files are allowed.");
//     }
//   };

//   const handleUpload = () => {
//     if (!selectedFile) {
//       console.log("Select a file first.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", selectedFile);

//     uploadFile(formData);
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-md w-[400px] p-6">
//         <h2 className="text-lg font-semibold mb-4">Upload Enrollment File</h2>

//         {/* DRAG & DROP AREA */}
//         <div
//           className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center cursor-pointer"
//           onClick={() => inputRef.current.click()}
//           onDragOver={(e) => e.preventDefault()}
//           onDrop={handleDrop}
//         >
//           {selectedFile ? (
//             <p className="text-green-700 font-medium">
//               {selectedFile.name}
//             </p>
//           ) : (
//             <p className="text-gray-500">Click or drag CSV/Excel file here</p>
//           )}

//           <input
//             type="file"
//             ref={inputRef}
//             className="hidden"
//             accept=".csv, .xlsx, .xls"
//             onChange={handleFileSelect}
//           />
//         </div>

//         {/* BUTTONS */}
//         <div className="flex justify-end gap-3 mt-6">
//           <button
//             className="px-4 py-2 rounded bg-gray-200 text-gray-800"
//             onClick={() => setOpen(false)}
//           >
//             Cancel
//           </button>

//           <button
//             className="px-5 py-2 rounded bg-blue-600 text-white"
//             disabled={isLoading}
//             onClick={handleUpload}
//           >
//             {isLoading ? <TailwindSpinner /> : "Upload"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UploadModal;
